export const reviews = [
  {
    id: 1,
    name: "Kirsten Cunliffe",
    rating: 5,
    text: "Without a doubt the best facial I’ve ever had. Included a face, neck, and shoulder massage which was relaxing from start to finish. Ellie is professional, knowledgeable, and made me feel completely at ease. My skin felt amazing afterwards—refreshed, glowing and soft. This wasn’t my first visit and it definitely won’t be my last.",
    service: "Facial Treatment",
  },
  {
    id: 2,
    name: "Karen Harrison",
    rating: 5,
    text: "The best facials you will ever have. Not only is Elisha an expert in skin care, she is amazing at creating the most serene, relaxing experience. I always leave feeling refreshed and glowing and my skin has never been better! Highly recommend.",
    service: "Facial Treatment",
  },
  {
    id: 3,
    name: "Nicola DeRoma",
    rating: 5,
    text: "Can’t recommend Radiance Aesthetics enough. I’ve been having regular facials with Ellie for the last 12 months and my skin is the best it’s ever been. Skin care can be confusing but Ellie is so good at looking at your skin and building treatments around your current skins needs. From the moment you walk in you will feel so relaxed and calm and will leave with glowing skin. Thanks Ellie",
    service: "Facial Treatment",
  },
  {
    id: 4,
    name: "Rhian Rees",
    rating: 5,
    text: "I’ve been having microneedling facials with Elisha and honestly couldn’t recommend them more! My skin feels so much smoother, brighter, and healthier after every treatment. El is so kind and sweet, always make me feel completely comfortable. I’ve noticed such a difference in my skin already, and I’ll definitely be back for more!",
    service: "Microneedling Facial",
  },
  {
    id: 5,
    name: "Molly Caley",
    rating: 5,
    text: "Ellie’s facials are utterly magical✨ they are soooo relaxing with a luxury feel☁️I feel able to leave all my worries at the door. I trust Ellie and her immense knowledge in skin care to choose what facial will work best for me. My skin has never looked or felt better. I am currently suffering from acne and the noticeable difference from my last facial is incredible. I will be coming for facials every 6 weeks and won’t be going anywhere else. See you soon!🧖🏼‍♀️",
    service: "Facial Treatment",
  },
  {
    id: 6,
    name: "Annie Howard",
    rating: 5,
    text: "I’ve been to Ellie for several facial treatments over the last 7 months and highly recommend her clinic. From her initial consultation in a beautiful relaxing clinic room ( including a heated couch) to throughout her aftercare check ins she is professional, caring, gentle and excellent in the services she gives. I’ve had derma-planing facials for over 10 years but Ellie’s are far superior to ones I’ve had and enjoyed before . Her treatments are so relaxing and leaves your skin feeling amazing for several weeks.",
    service: "Facial Treatment",
  },
  {
    id: 7,
    name: "Donna Barwise",
    rating: 5,
    text: `I’ve been having regular derma-planing facials off Elisha, absolutely 100% THE BEST ever!\nNever had a facial like it!\nMy skin is so soft and smooth afterwards for many many days\nElisha is beautiful, always on hand to offer advice, the surroundings are amazing and so relaxing!`,
    service: "Facial Treatment",
  },
  {
    id: 8,
    name: "Rebecca Hicks",
    rating: 5,
    text: "My facial with Elisha was incredible, I trusted her knowledge therefore let Elisha do what she thought my skin needed. I have had quite a few facials before and by far, I would say this is the best, time was spent analysing my skin. I really would like to highlight the passion and knowledge Elisha has for all things skin, recommendations were made to what products she believes I would benefit from and not only did I see results immediately after my facial but, I am still seeing results now, weeks later. I really can’t wait for my next facial, she truly is a skin queen 🫶🏼",
    service: "Facial Treatment",
  },
  {
    id: 9,
    name: "Dawn Roberts",
    rating: 5,
    text: `Radiance aesthetics is a lovely space, elisha is very professional and knowledgeable about skincare,the facials are so relaxing when I come away I feel pampered and my skin looks healthy and glowing,the products she uses are excellent and I have purchased some medic8 products which are fantastic and excellent value for money, I would recommend trying a facial you won't be disappointed`,
    service: "Facial Treatment",
  },
  {
    id: 10,
    name: "Latitia West",
    rating: 5,
    text: "I keep returning to Ellie whenever I can because I can honestly say that having one of her treatments is the best facial I've ever had. Ellie really takes her time to understand your skin and I benefit from her treatment for weeks afterwards - makes such a difference to the health and look of my skin. Fantastic Ellie; thank you so much!",
    service: "Facial Treatment",
  },
  {
    id: 11,
    name: "Rebecca Shala",
    rating: 5,
    text: `Facials with Ellie are pure bliss, she has a deep passion for dermatology and really knows how to care for your skin. It is also deeply relaxing, you feel safe in a beautiful space. It is the ultimate treat.`,
    service: "Facial Treatment",
  },
  {
    id: 12,
    name: "Julia Sixsmith",
    rating: 5,
    text: `Eli is amazing! I've been for several treatments now and have benefitted from every one and in many ways. The room is beautiful and so relaxing and the products Eli uses are 1st class. It's wonderful to have time for me when I feel so relaxed and looked after. I'm looking forward to my next appointment.😊`,
    service: "Facial Treatment",
  },
  {
    id: 13,
    name: "Annie Dewberry",
    rating: 5,
    text: `I had the most amazing facial & my skin was glowing afterwards. Ellie is a wonderful therapist & made it an incredibly relaxing experience in a beautiful treatment room. Highly recommend 👌 🥰`,
    service: "Facial Treatment",
  },
  {
    id: 14,
    name: "Helen O'Neill",
    rating: 5,
    text: "I won an Instagram completion for a Dermalux Facial which I had yesterday. A fabulous treatment which has left my skin feeling great, especially in these cold months. Ellie keeps everything so relaxed and calm and the studio is lovely a cosy. I will most definitely be returning for future treatments. Ellie is a true professional and I can't recommend her enough!",
    service: "Facial Treatment",
  },
  {
    id: 15,
    name: "Valerie Clayton",
    rating: 5,
    text: "Beautiful relaxing calming room pleasant atmosphere and friendly inviting environment. Very experienced in the treatments Elle offers",
    service: "Facial Treatment",
  },
];
